import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  setConnectOnlyWithAudio,
  setIdentity,
  setRoomId,
  setFromJid,
  setToJid,
} from "../store/actions";
import ErrorMessage from "./ErrorMessage";
import JoinRoomButtons from "./JoinRoomButtons";
import JoinRoomInputs from "./JoinRoomInputs";
import OnlyWithAudioCheckbox from "./OnlyWithAudioCheckbox";
import PreviewWindow from "./previewWindow";
import { getRoomExists } from "../utils/api";
import { useNavigate } from "react-router-dom";

const JoinRoomContent = (props) => {
  const {
    isRoomHost,
    setConnectOnlyWithAudio,
    connectOnlyWithAudio,
    setIdentityAction,
    setRoomIdAction,
    setFromJidAction,
    setToJidAction,
    autoRoomId,
    autoName,
    onShowPreview  // New prop to communicate preview state to parent
  } = props;
  const [roomIdValue, setRoomIdValue] = useState(autoRoomId || "");
  const [nameValue, setNameValue] = useState(autoName || "");
  const [errorMessage, setErrorMessage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const joinViaMeetingLink = async () => {
      if (!autoRoomId || !autoName || isRoomHost) return;

      // Check if the room exists on the server
      const response = await getRoomExists(autoRoomId);
      const { roomExists, full } = response;

      // if (!roomExists) {
      //   setErrorMessage("Meeting not found. Check your meeting link.");
      //   return;
      // }

      if (full) {
        setErrorMessage("Meeting is full. Please try again later.");
        return;
      }

      // Set Redux state
      setRoomIdAction(autoRoomId);
      setIdentityAction(autoName);

      // Show preview window by notifying parent
      setShowPreview(true);
      if (onShowPreview) {
        onShowPreview(true);
      }
    };

    joinViaMeetingLink();
  }, [autoRoomId, autoName, isRoomHost, setRoomIdAction, setIdentityAction, onShowPreview]);

  const handleJoinToRoom = async () => {
    // Validate inputs
    if (!nameValue.trim()) {
      setErrorMessage("Please enter your name");
      return;
    }

    if (!roomIdValue.trim()) {
      setErrorMessage("Please enter a meeting ID");
      return;
    }

    setErrorMessage(null);
    
    const responseMessage = await getRoomExists(roomIdValue);
    const { roomExists, full } = responseMessage;
    
    setIdentityAction(nameValue);
    setRoomIdAction(roomIdValue);

    if (full) {
      setErrorMessage("Meeting is full. Please try again later.");
    } else {
      // Show preview window before joining
      setShowPreview(true);
      if (onShowPreview) {
        onShowPreview(true);
      }
    }
  };

  const handlePreviewJoin = () => {
    // Navigate to room after preview
    navigate("/room");
  };

  const handlePreviewCancel = () => {
    // Close preview window
    setShowPreview(false);
    if (onShowPreview) {
      onShowPreview(false);
    }
  };

  return (
    <>
      <JoinRoomInputs
        roomIdValue={roomIdValue}
        setRoomIdValue={setRoomIdValue}
        nameValue={nameValue}
        setNameValue={setNameValue}
        isRoomHost={isRoomHost}
      />
      <OnlyWithAudioCheckbox
        setConnectOnlyWithAudio={setConnectOnlyWithAudio}
        connectOnlyWithAudio={connectOnlyWithAudio}
      />
      <ErrorMessage errorMessage={errorMessage} />
      <JoinRoomButtons
        handleJoinToRoom={handleJoinToRoom}
        isRoomHost={isRoomHost}
      />
    </>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    ...state,
  };
};

const mapActionsToProps = (dispatch) => {
  return {
    setConnectOnlyWithAudio: (onlyWithAudio) =>
      dispatch(setConnectOnlyWithAudio(onlyWithAudio)),
    setIdentityAction: (identity) => dispatch(setIdentity(identity)),
    setRoomIdAction: (roomId) => dispatch(setRoomId(roomId)),
    setFromJidAction: (fromJid) => dispatch(setFromJid(fromJid)),
    setToJidAction: (toJid) => dispatch(setToJid(toJid)),
  };
};

export default connect(
  mapStoreStateToProps,
  mapActionsToProps
)(JoinRoomContent);